export default "__VITE_ASSET__RPOo$IJR__"